import { render, staticRenderFns } from "./LanguageRadioGroup.vue?vue&type=template&id=c4792bb8&"
import script from "./LanguageRadioGroup.vue?vue&type=script&lang=js&"
export * from "./LanguageRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./LanguageRadioGroup.vue?vue&type=style&index=0&id=c4792bb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports